var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolleyball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_469_7216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6915 18.2921C14.4416 19.849 11.781 20.6799 9.04791 20.6799C8.74678 20.6799 8.44495 20.6698 8.14246 20.6495C5.97435 20.5039 3.89843 19.8428 2.0752 18.7401C2.49425 19.3522 2.97244 19.9303 3.5083 20.4662C5.77554 22.7334 8.78997 23.982 11.9963 23.982C14 23.982 15.9287 23.4944 17.647 22.5753C17.5921 21.1013 17.2667 19.647 16.6915 18.2921Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1928 0.174477C11.4964 0.963967 9.16034 2.67518 7.58319 5.02743C6.01476 7.36664 5.3213 10.1633 5.60667 12.9552C7.58361 12.9552 9.55797 12.4622 11.3078 11.5242C11.3817 9.27596 12.0163 7.08051 13.1543 5.14854C14.11 3.52619 15.399 2.11981 16.924 1.02614C16.0544 0.634329 15.1387 0.348439 14.1928 0.174477Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.223 11.571C18.9816 9.04343 16.9068 7.04474 14.3467 5.89588C13.3376 7.62172 12.7761 9.58094 12.7129 11.5872C14.6229 12.7753 16.2069 14.4225 17.311 16.3741C18.2431 18.0216 18.8175 19.8517 18.999 21.7297C19.522 21.3524 20.0188 20.9311 20.4837 20.4662C20.6991 20.2508 20.9052 20.0285 21.102 19.8001C21.7918 17.047 21.4835 14.1374 20.223 11.571Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18626 12.8684C3.92762 9.82701 4.70614 6.79251 6.41491 4.24398C7.59664 2.48147 9.16066 1.04157 10.9717 0.017952C8.15177 0.254747 5.53211 1.46611 3.50809 3.49008C1.33843 5.65973 0.102455 8.51375 0 11.5652C1.30439 12.2507 2.7262 12.6924 4.18626 12.8684Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9558 12.7729C10.0062 13.8146 7.8297 14.362 5.62717 14.362V14.3614C3.39355 14.3614 1.76051 13.9307 0.0488281 13.1547C0.138388 14.0815 0.334155 14.9855 0.629048 15.853C2.67355 17.8508 5.36444 19.0532 8.23633 19.246C11.0328 19.4338 13.7892 18.6447 16.0584 17.0172C15.0687 15.2875 13.6564 13.8274 11.9558 12.7729Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1377 4.71134C17.8983 6.00837 20.1348 8.19866 21.4866 10.9509C22.4331 12.8779 22.8982 14.9787 22.8674 17.0834C23.6092 15.5065 24.0005 13.7724 24.0005 11.9781C24.0005 8.7718 22.7518 5.75737 20.4846 3.49008C19.8248 2.83029 19.1014 2.25743 18.3287 1.77587C17.0971 2.55439 16.0145 3.55142 15.1377 4.71134Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_469_7216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolleyball);
export default __webpack_public_path__ + "static/media/volleyball.fb865e474287005d04c2df57741a9b47.svg";
export { ForwardRef as ReactComponent };